export default __webpack_public_path__ + "static/media/Checklist-amico.acb38aa8.png";